// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"search_searchBar__bFPnS","autoCompleteList":"search_autoCompleteList__Hyfzo","autoCompleteItem":"search_autoCompleteItem__xNjZ3"};